export default "__VITE_ASSET__9ZRVB3sH__"